import React, {useState} from "react";
import { useNavigate, Link } from 'react-router-dom';
import Navbar from "../../components/Navbar";
import "./login.css";
import axios from "axios";
import url from "../../function/url";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
function Company_Login() {

  const navigate = useNavigate(); // Get the navigate function
  const [username,setUsername] = useState("");
  const [password,setPassword] = useState("");
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    },
  });
  const handleLogin = (event) => {
    event.preventDefault();
    const data = {
      username:username,
      password:password,
    }
    axios
    .post(`${url.path}/login/`,data)
    .then((res) => {
      if (res.data.status) {
        Cookies.set('User',res.data.user);
        Cookies.set('log_id',res.data.login_id);
        if (res.data.redirect != ""){
          navigate('/'+res.data.redirect);
        }
      }
    })
    .catch((err) => {
      if(!err.response.data.status){
        Swal.fire({
          icon: "error",
          title: `${err.response.data.message}`,
        });
      }
    });
  };
  return (
    <>
    <Navbar/>
    <div className="login-container">
      <div className="login-box">
        {/* Left Section: Login Form */}
        <div className="login-form">
          <div className="logo">
            <h1>SIGN IN</h1>
          </div>
          <h2></h2>
          
          <form onSubmit={handleLogin}>
            <div className="form-group">
            
              <input type="text" placeholder="Username" value={username} onChange={(e) =>setUsername(e.target.value)}  />
            </div>
            <div className="form-group">
              
              <input type="password" placeholder=" Password" value={password} onChange={(e) =>setPassword(e.target.value)} />
              <a href="#" className="forgot-password">Forgot password</a>
            </div>
            <button type="submit" className="sign-in-btn">Sign in</button>
            <button type="button" className="google-btn">
              <img
                src="https://img.icons8.com/color/24/000000/google-logo.png"
                alt="Google Logo"
              />
              Sign in with Google
            </button>
          </form>
          <p className="sign-up-text">
  Don’t have an account?{" "}
  <Link 
    to="/company_registration" 
    style={{
      color: "#001F54", 
      textDecoration: "none", 
      fontWeight: "bold"
    }}
  >
    Sign up
  </Link>
</p>

        </div>

        {/* Right Section: Texts and Illustration */}
        <div className="login-right">
  <div className="right-content">
    <h2>Empower Your Future</h2>
    <p>Take the next step in your career journey with Job Market—opportunities are waiting for you!</p>
  </div>
</div>

      </div>
    </div>
    </>
  );
}

export default Company_Login;
